import axios from 'axios'
import CommonRouter from './commonRoute'
import { getCookie, removeCookie, getPageOrigin, getUserIpAddress } from './commonFunction'
const { apiEndpoint } = require('./commonApi')
const service = axios.create({
  headers: {

  }
})
const handleSuccess = (response) => {
  return response
}

const handleError = (error) => {
  return Promise.reject(error)
}
service.interceptors.response.use(handleSuccess, handleError)

/**
 * IW0079
 * When someone changes in local storage detail at that time that person account will logout for security purpose
 */
const renewToken = () => {
  if (!window.location.pathname.includes('/s/') || !window.location.pathname.includes('/p/')) {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_tokens')
    localStorage.removeItem('userData')
    window.location.href = CommonRouter.log_in
  }
}
const publicApiPaths = ['sign-up', 'generate-user-otp', 'generate-login-otp', 'forgot-password', 'log-in', 'verify-user-otp', 'reset-password', 'update-aff-visit-count', 'utm-meta-tag']
const isPublicApiPath = (path) => publicApiPaths.some((publicPath) => path.includes(publicPath))

export const ApiCall = async (method, path, payload, header, timeout = 10000, isIpAddress = false) => {
  const requestHeaders = {
    ...(header && typeof header === 'object' ? header : {}),
    Origin: getPageOrigin()
  }
  if (isIpAddress) {
    requestHeaders.ip = await getUserIpAddress()
  }
  if (requestHeaders && !requestHeaders['access-token'] && !isPublicApiPath(path)) {
    renewToken()
  } else {
    try {
      const responce = await service.request({
        method,
        url: apiEndpoint + path,
        responseType: 'json',
        data: payload,
        timeout,
        headers: requestHeaders
      })
      return responce
    } catch (error) {
      if (error.message === 'Network Error') {
        console.log(`${error}, Server is not responding, please try again after some time`)
      }
      if (error.response?.data?.statusCode === 401 && requestHeaders && !requestHeaders['access-token']) {
        if (error.response.data.access_expire) {
          renewToken()
        } else if (error.response.data.refresh_expire) {
          return error.response
        }
      } else {
        return error.response
      }
    }
  }
}

/**
 * IW0079
 * here flag is true when api call occur and user is not login
 */
export const GetApiCall = async (method, path, header, flag = false) => {
  const requestHeaders = {
    ...(header && typeof header === 'object' ? header : {}),
    Origin: getPageOrigin()
  }
  if (!requestHeaders['access-token'] && !flag) {
    renewToken()
  } else {
    try {
      const responce = await service.request({
        method,
        url: apiEndpoint + path,
        responseType: 'json',
        headers: requestHeaders

      })
      return responce
    } catch (error) {
      if (error.message === 'Network Error') {
        console.log(`${error}, Server is not responding, please try again after some time`)
      }
      if (error.response?.data?.statusCode === 401) {
        if (error.response.data.access_expire) {
          renewToken()
        } else {
          return error.response
        }
      } else {
        return error.response
      }
    }
  }
}

export const nodeSetCookie = async (path, payload) => {
  // Check if old cookie exists and remove it
  if (getCookie(payload.key)) {
    removeCookie(payload.key)
  }
  const cookieData = fetch(apiEndpoint + path, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(data => data.data)
    .catch(err => console.error(err))
  return cookieData
}

export const nodeGetCookie = async (path) => {
  const cookieData = fetch(apiEndpoint + path, {
    method: 'GET',
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => data.data)
    .catch(err => console.error(err))
  return cookieData
}